import { gateway } from "src/gateway";

export interface IAssignPhoneNumberPayload {
  subscriptionId: string;
  externalId: string;
}

export const assignPhoneNumber = async (payload: IAssignPhoneNumberPayload): Promise<any> => {
  const response = await gateway.post(
    "/subscriptions/assign-phone-number",
    payload
  );
  return response.data;
};
